/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var config = require('../config');

var topicCodeMap = {
    100: '发送成功',
    102: '管理员禁止发布话题',
    103: '该用户被禁言',
    104: '不允许匿名发表话题',
    105: '内容和图片不能同时为空',
    106: '管理员禁止回复'
};

var defaultOption = {
    'topicType': '1' // 獲取已審核內容
};

var pageSizeWhenFetchTopicList = 10;

var Topic = function () {
    function Topic(_ref) {
        var act_id = _ref.act_id,
            topic_visitor_publish = _ref.topic_visitor_publish,
            topic_needs_check = _ref.topic_needs_check,
            topic_allow_reply = _ref.topic_allow_reply,
            topic_count_num = _ref.topic_count_num,
            tracker = _ref.tracker;
        (0, _classCallCheck3["default"])(this, Topic);

        _scope.Feature.EventBus(this);

        this.topic_visitor_publish = !!topic_visitor_publish;
        this.topic_needs_check = !!topic_needs_check;
        this.topic_allow_reply = !!topic_allow_reply;
        this.act_id = act_id;
        this.tracker = tracker;

        this.SetCount(topic_count_num || 0);

        this._rop();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Topic, [{
        key: '_rop',
        value: function _rop() {
            var _this = this;

            rop.On('topic-' + this.act_id, function (data) {
                _scope.MsgBus.Pub('Topic.New', (0, _stringify2["default"])(_this._filterTopicReplies(JSON.parse(data))));
            });

            rop.On('topic_set_top_' + this.act_id, function (data) {
                _scope.MsgBus.Pub('Topic.Top', (0, _stringify2["default"])(_this._filterTopicReplies(JSON.parse(data))));
            });

            rop.On('topic_allow_reply_' + this.act_id, function (data) {
                var status = JSON.parse(data).status;
                _this.topic_allow_reply = !!status;
                _scope.MsgBus.Pub('Topic.AllowReply', _this.topic_allow_reply);
            });

            rop.On('topic_visitor_publish_' + this.act_id, function (data) {
                var status = JSON.parse(data).status;
                _this.topic_visitor_publish = !!status;
                _scope.MsgBus.Pub('Topic.AllowPublish', _this.topic_visitor_publish);
            });

            rop.On('topic_needs_check_' + this.act_id, function (data) {
                var status = JSON.parse(data).status;
                _this.topic_needs_check = !!status;
                _scope.MsgBus.Pub('Topic.NeedsCheck', _this.topic_needs_check);
            });

            rop.On('topic-reply-' + this.act_id, function (data) {
                _scope.MsgBus.Pub('Topic.Reply.New', data);
            });

            rop.On('topic_del_' + this.act_id, function (data) {
                _scope.MsgBus.Pub('Topic.Delete', data);
            });
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                rop.Remove('topic-' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.New');
                rop.Remove('topic_set_top_' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.Top');
                rop.Remove('topic_allow_reply_' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.AllowReply');
                rop.Remove('topic_visitor_publish_' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.AllowPublish');
                rop.Remove('topic_needs_check_' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.NeedsCheck');
                rop.Remove('topic-reply-' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.Reply.New');
                rop.Remove('topic_del_' + _this2.act_id);
                _scope.MsgBus.UnSubAll('Topic.Delete');

                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);
            });
        }
    }, {
        key: 'UnSubTopics',
        value: function UnSubTopics() {
            rop.Remove('topic-' + this.act_id);
            rop.Remove('topic_set_top_' + this.act_id);
            rop.Remove('topic_allow_reply_' + this.act_id);
            rop.Remove('topic_visitor_publish_' + this.act_id);
            rop.Remove('topic_needs_check_' + this.act_id);
            rop.Remove('topic-reply-' + this.act_id);
            rop.Remove('topic_del_' + this.act_id);
        }
    }, {
        key: '_filterTopicReplies',
        value: function _filterTopicReplies(topic) {
            var selfVisitorId = _scope.DB.Get('UserInfo').id;
            topic.replies = (topic.replies || []).filter(function (v) {
                return !(!v.checked && selfVisitorId != v.visitor_id);
            });
            return topic;
        }
    }, {
        key: 'SendTopic',
        value: function SendTopic() {
            var _this3 = this;

            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var cb = arguments[1];

            if (!obj.msg && (!obj.images || !obj.images.length)) {
                return;
            }
            obj.msg = obj.msg || '';
            obj.images = obj.images || [];

            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/setTopic';
            var param = {
                // visitor_id:  _scope.Utils.GetCookie('visitorId'),
                // avatar:  _scope.Utils.GetCookie('avatar'),
                // username:  _scope.Utils.GetCookie('user'),
                images: obj.images.join(','),
                message: obj.msg
            };
            var callback = function callback(response) {
                var res = JSON.parse(response);
                if (typeof cb === 'function') {
                    cb((0, _stringify2["default"])({
                        status: res.status,
                        flag: res.flag,
                        info: topicCodeMap[res.flag] || '',
                        hasBadWord: res.hasBadWord,
                        word: res.word,
                        topicNeedsChecked: res.topicNeedsChecked
                    }));
                }
                var tracker = _this3.tracker;
                if (tracker && 'function' === typeof tracker.triggerEvent && res.flag == 100) {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'topic'
                    });
                }
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
        }
    }, {
        key: 'SendReply',
        value: function SendReply() {
            var _this4 = this;

            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var cb = arguments[1];

            if (!obj.topicId || !obj.msg) {
                return;
            }
            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/setTopic';
            var param = {
                belong_to: +obj.topicId,
                // visitor_id:  _scope.Utils.GetCookie('visitorId'),
                // avatar:  _scope.Utils.GetCookie('avatar'),
                // username:  _scope.Utils.GetCookie('user'),
                message: obj.msg
            };
            var callback = function callback(response) {
                var res = JSON.parse(response);
                if (typeof cb === 'function') {
                    cb((0, _stringify2["default"])({
                        status: res.status,
                        flag: res.flag,
                        info: topicCodeMap[res.flag] || '',
                        hasBadWord: res.hasBadWord,
                        word: res.word,
                        topicNeedsChecked: res.topicNeedsChecked
                    }));
                }
                var tracker = _this4.tracker;
                if (tracker && 'function' === typeof tracker.triggerEvent && res.flag == 100) {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'topic'
                    });
                }
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
        }
    }, {
        key: 'Get',
        value: function Get(pageId, options, cb) {
            cb = typeof options === 'function' ? options : cb;
            options = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3["default"])(options)) === 'object' ? (0, _assign2["default"])({}, defaultOption, options) : defaultOption;
            this._get(pageId, options, cb);
        }
    }, {
        key: '_get',
        value: function _get(pageId, options, cb) {
            var _this5 = this;

            if (!+pageId) {
                return;
            }
            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/getTopic';

            var param = {
                topicType: options.topicType, //'1'已审核；'0'未审核；'all'全部
                pageSize: pageSizeWhenFetchTopicList,
                pageIndex: +pageId || 1
            };

            var callback = function callback(response) {
                var res = JSON.parse(response);
                if (Object.prototype.toString.call(res.topics) === '[object Array]') {
                    res.topics = res.topics.map(function (v) {
                        return _this5._filterTopicReplies(v);
                    });
                }
                if (typeof cb === 'function') {
                    cb((0, _stringify2["default"])(res));
                }
            };
            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
        }
    }, {
        key: 'GetAllowReply',
        value: function GetAllowReply() {
            return this.topic_allow_reply;
        }
    }, {
        key: 'GetAllowPublish',
        value: function GetAllowPublish() {
            return this.topic_visitor_publish;
        }
    }, {
        key: 'GetNeedsCheck',
        value: function GetNeedsCheck() {
            return this.topic_needs_check;
        }
    }, {
        key: 'SetCount',
        value: function SetCount(count) {
            this.count = count;
            this.page = Math.ceil(count / pageSizeWhenFetchTopicList);
        }
    }, {
        key: 'GetPage',
        value: function GetPage() {
            return this.page;
        }
    }]);
    return Topic;
}();

module.exports = Topic;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Topic.js
 ** module id = 181
 ** module chunks = 1
 **/